/**
 * NovelSprig 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * NovelSprig 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFF3FA',
  popupTagColor: '#4B5563',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#EFF3FA',
  filterActiveBgColor: '#D1FAE5',
  filterColor: '#4B5563',
  filterActiveColor: '#10B981',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
